import apiClient from "../../../helpers/apiClient";

const resolvePostLoginRedirect = async (history) => {
    try {
        const companyRes = await apiClient.get("/api/company/my-company");

        if (companyRes?.data?.success) {
            const company = companyRes.data.data;

            if (!company?.onboardingSteps?.completed) {
                history.push("/onboarding");
                return;
            }
        }
    } catch {
        history.push("/onboarding");
        return;
    }

    history.push("/");
};

export default resolvePostLoginRedirect;
